module.exports = __webpack_public_path__ + "img/logo.b7dbe4d2.jpg";